<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <!-- {{ selection }}<br /> -->
    <b-card class="standardpage reports">
      <b-card-group deck class="mt-2">
        <b-row no-gutters class="w-100pct">
          <b-col :cols="cards" v-for="(order, index) in items" :key="index" class="mb-2">
            <!-- {{ order.tile.data.raw }} -->
            <b-card no-body>
              <b-card-header class="text-center bg-light">
                <div class="overspent" v-if="parseFloat(order.value) - parseFloat(order.spent) < 0">
                  <span>Overspent</span>
                </div>
                <!-- <span class="small">
                  <span class="h6 text-primary" v-if="order.eventcode">
                    {{ order.eventname }}<br />
                  </span>
                  Ref: {{ order.yourref }}, <br />Date: {{ order.dateplaced }}
                </span> -->
                <div v-if="order.yourref" title="Your Ref">
                  Your Ref: {{ order.yourref }}
                </div>
                <!-- <b-row
                  align-v="center"
                  no-gutters
                  class="justify-content-md-left text-dark"
                >
                  <b-col cols="auto mr-3"
                    ><i class="fa fa-gavel fa-3x"></i
                  ></b-col>
                  <b-col cols="auto" class="text-left">
                    <div class="h4 text-primary strong" title="Your Ref / PO">
                      {{ order.yourref }}
                    </div>

                    <div class="small" title="Date Placed">
                      {{ order.dateplaced }}
                    </div>
                  </b-col>
                </b-row> -->
              </b-card-header>
              <b-card-body>
                <!-- <b-card-title
                  ><i class="fa fa-gavel"></i> Your Ref: {{ order.yourref }}
                  <br />
                </b-card-title> -->

                <b-card-text class="text-center" v-if="order.eventname">
                  {{ order.slac }}, Event: {{ order.eventname }}
                </b-card-text>
                <b-card-text class="text-center" v-else>
                  {{ order.slac }}, Event: Various
                </b-card-text>
                <!-- <b-card-text> Placed: {{ order.dateplaced }}</b-card-text> -->
                <OrderPie v-if="order.tile" :tile="order.tile" />
              </b-card-body>
              <div class="p-3">
                <b-list-group class="small text-muted" vertical>
                  <b-list-group-item>Order Value <span class="float-right">{{
                      order.value | currency("£")
                      }}</span> </b-list-group-item>
                  <b-list-group-item>Invoices & Credits <span class="text-warning float-right">{{
                      order.spent | currency("£")
                      }}</span></b-list-group-item>
                  <b-list-group-item>VAT Reclaim <span class="text-info float-right">{{
                      order.reclaim | currency("£")
                      }}</span></b-list-group-item>
                  <b-list-group-item>Remaining <span class="text-primary float-right">{{
                      order.remaining | currency("£")
                      }}</span></b-list-group-item>
                </b-list-group>
              </div>
              <!-- <b-card-footer class="border-none">
                <b-row v-if="legend" class="mt-2 pl-2 eventcalendar">
                  <b-col cols="auto" class="legend mb-3">
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-gray-dark">
                        <b-row>
                          <b-col>
                            <div
                              class="inline mt-1 border-secondary bg-gray-dark mr-1"
                            ></div>
                            <span>TOTAL</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center"
                            ><span>{{
                              order.value | currency("£")
                            }}</span></b-col
                          >
                        </b-row>

                        <br />
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="auto" class="legend mb-3">
                    <b-row align-v="center" no-gutters>
                      <b-col>
                        <b-row>
                          <b-col>
                            <div class="inline">
                              <div
                                class="
                                  inline
                                  mt-1
                                  border-secondary
                                  bg-warning
                                  mr-1
                                "
                              ></div>
                              <span class="text-warning">INVOICE</span>
                            </div>
                            <div class="inline mx-1"><span>+</span></div>
                            <div class="inline">
                              <div
                                class="
                                  inline
                                  mt-1
                                  border-secondary
                                  bg-gray-dark
                                  mr-1
                                "
                              ></div>
                              <span class="text-gray-dark">CREDIT</span>
                            </div></b-col
                          >
                        </b-row>

                        <b-row>
                          <b-col class="text-center">
                            <span class="text-warning">{{
                              order.spent | currency("£")
                            }}</span></b-col
                          >
                        </b-row>

                        <br />
                      </b-col>
                    </b-row>
                  </b-col>


                  <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="order.tile.data.raw.find((k) => k.key == 'Forecast')"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-purple">
                        <b-row>
                          <b-col>
                            <div
                              class="
                                inline
                                mt-1
                                border-secondary
                                bg-purple
                                mr-1
                              "
                            ></div>
                            <span>FORECAST</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center">
                            <span>{{
                              order.forecast | currency("£")
                            }}</span></b-col
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>


                  <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="parseFloat(order.remaining) > 0"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-success">
                        <b-row>
                          <b-col>
                            <div
                              class="
                                inline
                                mt-1
                                border-secondary
                                bg-success
                                mr-1
                              "
                            ></div>
                            <span>REMAINING</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center">
                            <span>{{
                              order.remaining | currency("£")
                            }}</span></b-col
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="parseFloat(order.remaining) < 0"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-danger">
                        <b-row>
                          <b-col>
                            <div
                              class="inline mt-1 border-secondary bg-danger mr-1"
                            ></div>
                            <span>OVERSPENT</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center">
                            <span>{{
                              order.remaining | currency("£")
                            }}</span></b-col
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card-footer> -->
            </b-card>
          </b-col>
        </b-row>
      </b-card-group>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>


<script>
import gql from "graphql-tag";

import OrderPie from "../../../Tiles/OrderPie.vue";

export default {
  name: "OrdersSpend",
  components: {
    OrderPie,
  },
  data() {
    return {
      busy: false,
      legend: true,
      find: "",
      items: [],
      options: {
        debounce: 500,
      },
    };
  },
  computed: {
    cards() {
      if (this.items.length <= 2) {
        return 6;
      }
      if (this.window.width < 500) {
        return 12;
      } else if (this.window.width < 800) {
        return 6;
      } else if (this.window.width < 1200) {
        return 4;
      } else {
        return 3;
      }
    },
  },
  methods: {
    async load() {
      this.busy = true;

      this.items = [];
      for (var k = 0; k < this.selection.length; k++) {
        let item = { ...this.selection[k] };

        let variables = {
          yourref: item.yourref,
          slac: item.slac,
          eventcode: item.eventcode,
          // dateformat: "DD/MM/YYYY HH:MM",
        };

        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query chart_orderspent(
                $eventcode: String
                $yourref: String
                $slac: String
              ) {
                chart_orderspent(
                  eventcode: $eventcode
                  yourref: $yourref
                  slac: $slac
                ) {
                  labels
                  datasets {
                    data
                  }
                  raw {
                    key
                    value
                  }
                }
              }
            `,
            variables,
          });


          if (response.data.chart_orderspent) {
            item.tile = {
              settings: [
                {
                  key: "type",
                  label: "Chart Type",
                  type: "radio-group",
                  buttons: true,
                  "button-variant": "outline-primary",
                  values: [{ value: "horizontalbar", text: "Horizontal Bar" }],
                  value: "donut",
                },
                {
                  key: "server",
                  label: "Server",
                  type: "radio-group",
                  buttons: true,
                  "button-variant": "outline-primary",
                  values: [{ value: "LIVE", text: "LIVE" }],
                  value: "LIVE",
                },
                {
                  key: "title",
                  label: "Title",
                  type: "radio-group",
                  buttons: true,
                  "button-variant": "outline-primary",
                  values: [
                    { value: true, text: "On" },
                    { value: false, text: "Off" },
                  ],
                  value: false,
                  tab: "Annotate",
                },
                {
                  key: "titletext",
                  label: "Title Text",
                  type: "text",
                  value: "",
                  tab: "Annotate",
                },
                {
                  key: "holetext",
                  label: "Hole Text",
                  type: "text",
                  value: this.$options.filters.currency(item.value, "£"),
                  tab: "Annotate",
                },
                {
                  key: "legend",
                  label: "Legend",
                  type: "radio-group",
                  buttons: true,
                  "button-variant": "outline-primary",
                  values: [
                    { value: true, text: "On" },
                    { value: false, text: "Off" },
                  ],
                  value: false,
                  tab: "Annotate",
                },
                {
                  key: "legendposition",
                  label: "Legend Position",
                  type: "radio-group",
                  buttons: true,
                  "button-variant": "outline-primary",
                  values: [
                    { value: "top", text: "Top" },
                    { value: "bottom", text: "Bottom" },
                    { value: "left", text: "Left" },
                    { value: "right", text: "Right" },
                  ],
                  value: "bottom",
                  tab: "Annotate",
                },
                {
                  key: "datalabels",
                  label: "Data Labels",
                  type: "radio-group",
                  buttons: true,
                  "button-variant": "outline-primary",
                  values: [
                    { value: true, text: "On" },
                    { value: false, text: "Off" },
                  ],
                  value: false,
                  tab: "Annotate",
                },

                {
                  key: "titlefontnamesize",
                  label: "",
                  label_type: "Font Type",
                  label_size: "Font Size",
                  type: "fontsize",
                  values_type: [
                    { value: "Arial", text: "Arial" },
                    { value: "Helvetica Neue", text: "Helvetica Neue" },
                  ],
                  values_size: [
                    { value: "10", text: "10" },
                    { value: "12", text: "12" },
                    { value: "14", text: "14" },
                  ],
                  tab: "Fonts",
                },
              ],
              options: {
                actions: [
                  {
                    key: "settings",
                    label: "Settings",
                    icon: "fa fa fa-cog text-primary",
                  },
                  { divider: true },
                  {
                    key: "small",
                    label: "Small",
                    icon: "fa fa-th text-primary",
                  },
                  {
                    key: "large",
                    label: "Large",
                    icon: "fa fa-square text-primary",
                  },
                  { divider: true },
                  {
                    key: "delete",
                    label: "Delete",
                    icon: "fa fa-trash text-danger",
                  },
                ],
              },
              data: response.data.chart_orderspent,
            };

            this.items.push(item);
          }
        } catch (error) {
          console.log(error);
        }
      }

      console.log(this.items);

      this.busy = false;
    },
  },
};
</script>

<style>
</style>